import Actions from '../../odata/actions';

const actions = new Actions('productSpecSheetImage', 'productSpecSheetImages');

export default actions;
